import axios from "axios";

import AuthService from "./auth.service";

class HttpService {
  static get(url, headers = null) {
    let config = {
      headers: { "Content-Type": "application/json" },
    };
    if (headers) {
      Object.keys(headers).forEach((key) => {
        config.headers[key] = headers[key];
      });
    }
    const token = AuthService.getAccessToken();
    if (token) {
      config.headers["Authorization"] = "Bearer " + `${token}`;
      return axios.get(url, config);
    } else {
      return axios.get(url, config);
    }
  }

  static post(url, data, headers = null) {
    let config = {
      headers: { "Content-Type": "application/json" },
    };
    if (headers) {
      Object.keys(headers).forEach((key) => {
        config.headers[key] = headers[key];
      });
    }
    const token = AuthService.getAccessToken();
    if (token) {
      config.headers["Authorization"] = "Bearer " + `${token}`;
      return axios.post(url, data, config);
    } else {
      return axios.post(url, data, config);
    }
  }
}

export default HttpService;
